import React from "react";

const NoFiltersIcon = () => {
  return (
    <svg
      width="80"
      height="80"
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M31.9998 44.7251L47.9998 60.7251V68.0001C47.9998 69.6126 47.0248 71.0751 45.5248 71.7001C44.0248 72.3251 42.3123 71.9751 41.1623 70.8376L33.1623 62.8376C32.4123 62.0876 31.9873 61.0751 31.9873 60.0126C31.9873 55.2376 31.9873 50.4501 31.9873 45.6751V44.7501L31.9998 44.7251Z"
        fill="#BDBDBD"
      />
      <path
        d="M4.8748 4.8876C6.0498 3.7126 7.9498 3.7126 9.1123 4.8876L20.2248 16.0001H67.9998C69.6123 16.0001 71.0748 16.9751 71.6998 18.4751C72.3248 19.9751 71.9748 21.6876 70.8373 22.8376L48.9498 44.7126L75.1248 70.8876C76.2998 72.0626 76.2998 73.9626 75.1248 75.1251C73.9498 76.2876 72.0498 76.3001 70.8873 75.1251L4.8748 9.1376C3.7123 7.9626 3.7123 6.0626 4.8748 4.8876Z"
        fill="#BDBDBD"
      />
    </svg>
  );
};

export default NoFiltersIcon;
